function defiItemFields() {
  return {
    title: '',
    address: '',
    tx_hash: {},
    token: undefined,
    direction: 2,
  }
}

export { defiItemFields }
